import { UsersAPI } from "@/lib/api"
import User from "@/lib/user"
import { SET_USER, ASSIGN_FAMILIES, ADD_USER_NOTE } from "@/store/mutationTypes"
import Vue from "vue"

const state = {
  all: []
}

// getters
const getters = {
  getMe: state => {
    return state.all.find(el => el.id === User.getUserId())
  },
  getUser: state => id => {
    return state.all.find(el => el.id === parseInt(id))
  }
}

// actions
const actions = {
  loadUser: async function({ commit }, userId) {
    let res = UsersAPI.get(userId)
    res.then(
      function(res) {
        commit(SET_USER, res)
      },
      function(err) {
        if (err.includes("401")) {
          console.log(err)
        }
      }
    )
  },
  loadMe: async function({ commit }, userId) {
    commit(SET_USER, await UsersAPI.get(User.getUserId()))
  },

  updateAvatar: async function({ commit, dispatch }, { userId, file }) {
    await UsersAPI.updateAvatar(userId, file)
    await dispatch("loadUser", userId)
    await dispatch("loadMe")
  },
  updateUser: async function(
    { commit, dispatch },
    {
      id,
      firstName,
      lastName,
      nickname,
      phoneNumber,
      email,
      parentName1,
      parentName2,
      parentEmail1,
      parentEmail2,
      parentPhone1,
      parentPhone2,
      siblings,
      school,
      graduationYear,
      programStartDate,
      pro_d_order_number,
      disabled
    }
  ) {
    commit(
      SET_USER,
      await UsersAPI.update({
        id,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        nickname: nickname,
        email: email,
        parent_name_1: parentName1,
        parent_name_2: parentName2,
        parent_email_1: parentEmail1,
        parent_email_2: parentEmail2,
        parent_phone_1: parentPhone1,
        parent_phone_2: parentPhone2,
        siblings: siblings,
        school: school,
        graduation_year: graduationYear,
        program_start_date: programStartDate,
        pro_d_order_number: pro_d_order_number,
        disabled: disabled
      })
    )
    await dispatch("loadUser", id)
  },
  disableUser: async function({ commit }, userId) {
    let res = UsersAPI.disable(userId)
    res.then(
      function(res) {
        commit(SET_USER, res)
      },
      function(err) {
        if (err.includes("401")) {
          console.log(err)
        }
      }
    )
  },
  sendUserInvite: async function({ commit, dispatch }, userId) {
    await UsersAPI.sendInvite(userId)
    await dispatch("loadUser", userId)
  },
  fetchProD: async function({ commit, dispatch }, userId) {
    await UsersAPI.proDFetch(userId)
    await dispatch("loadUser", userId)
  },
  parseEnneagram: async function({ commit, dispatch }, userId) {
    await UsersAPI.parseEnneagram(userId)
  },
  assignFamilies: async function({ commit, dispatch }, { userId, familyIds }) {
    commit(ASSIGN_FAMILIES, await UsersAPI.assignFamilies(userId, familyIds))
    await dispatch("loadUser", userId)
  },
  addUserNote: async function({ commit, dispatch }, { userId, note }) {
    commit(ADD_USER_NOTE, await UsersAPI.addNote(userId, note))
    await dispatch("loadUser", userId)
  }
}

// mutations
const mutations = {
  [SET_USER](state, user) {
    let foundIndex = state.all.findIndex(el => el.id == user.id)
    if (foundIndex >= 0) {
      Vue.set(state.all, foundIndex, user)
    } else {
      state.all.push(user)
    }
  },
  [ASSIGN_FAMILIES](state, familyIds) {},
  [ADD_USER_NOTE]() {},
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
